import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const VALIDATION_RULES = {
  input: {
    minLength: 3,
    maxLength: 60,
  },
  text: {
    minLength: 3,
    maxLength: 60,
  },
  textArea: {
    minLength: 0,
    maxLength: 500,
  },
  password: {
    minLength: 6,
  },
  months: {
    maxLength: 2,
  },
  minutes: {
    maxLength: 4,
  },
  weight: {
    maxLength: 5,
  },
  loadNumber: {
    maxLength: 100,
  },
};

export const PASSWORD_PATTERN = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*?[\\W_])\\S{8,}$';
export const FRACTIONAL_NUMBER_PATTERN = new RegExp(/^\d+(\.\d+)*$/);
export const FRACTIONAL_POSITIVE_NUMBER_PATTERN = new RegExp(/^(?!0*(\.0*)?$)\d+(\.\d+)?$/);
export const INTEGER_FRACTIONAL_NUMBER_PATTERN = new RegExp(/^-?\d+(\.\d+)*$/);
export const NUMBER_PATTERN = new RegExp(/^([1-9]\d*|0)$/);
export const INTEGER_NUMBER_PATTERN = new RegExp(/^-?([1-9]\d*|0)$/);
export const NATURAL_NUMBER_PATTERN = new RegExp(/^\d*[1-9]\d*$/);
export const TIME_PATTERN = new RegExp(/([01]?[0-9]|2[0-3]):[0-5][0-9]/);
export const SSCCID_PATTERN = new RegExp(/^[0-9]{3}$/);
export const COMPARTMENT_SSCCID_PATTERN = new RegExp(/^[0-9]{4}$/);
export const PHONE_NUMBER_PATTERN_WITH_CODE_COUNTRY = new RegExp(/^\+(?:[0-9] ?){6,18}[0-9]$/);
export const PHONE_NUMBER_PATTERN = new RegExp(/[0-9]{6,18}$/);
export const EMAIL_PATTERN = new RegExp('^(([\\w\\-_/&\\*\\+]+)(\\.)?)+@[\\w\\-_]+(\\.[\\w\\-]+){1,}$');
export const BOSCH_EMAIL_PATTERN = new RegExp('^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\\.)?[a-zA-Z]+\\.)?(bosch)\\.com$');

export const VEHICLE_ID_PATTERN = new RegExp(/^\s*^[A-Z0-9 ÄÜÖ\\\-\u4E00-\u9FFF]*$/u);
export const LOAD_NUMBER_PATTERN = new RegExp(/^[a-zA-Z0-9\u4E00-\u9FFF-]*$/u);

export const DEFAULT_NUMBER_VALIDATORS: Validators[] = [Validators.required, Validators.pattern(NUMBER_PATTERN)];

export const DEFAULT_OPTIONAL_NUMBER_VALIDATORS: Validators[] = [Validators.pattern(NUMBER_PATTERN)];

export const MINUTES_VALIDATORS: Validators[] = [
  ...DEFAULT_NUMBER_VALIDATORS,
  numericMaxLength(VALIDATION_RULES.minutes.maxLength),
];

export const NO_SPACE_INBETWEEN_PATTERN = new RegExp(/^((?!\s{2,}).)*$/);

export function numericMaxLength(maxLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const actualLength = String(value).length;

    return actualLength <= maxLength
      ? null
      : {
          maxlength: {
            requiredLength: maxLength,
            actualLength,
          },
        };
  };
}
